import { get } from 'lodash';

export const getLastLoadedPageData = (state) => get(state, 'metaData.lastLoadedPageData');
